import React from 'react';
import dayjs from 'dayjs';
import { Box, Typography } from '@mui/material';
import { AnnouncementOutlined } from '@mui/icons-material';
import { DashboardMetricCardWrapper } from 'components/dashboard-metric-card';
import { useRatingSummary } from 'store/apis';
import { RatingSummaryCard } from './rating-summary';
import { IBuilding } from 'models';

interface ChartRatingSummaryProps {
  building: IBuilding;
  start: string;
  end: string;
}

function getDaysLabel(start: string, end: string): string {
  const startDate = dayjs(start);
  const endDate = dayjs(end);
  const days = endDate.diff(startDate, 'day');

  return `${days} days`;
}

export const ChartRatingSummary = ({ building, start, end }: ChartRatingSummaryProps) => {
  const { data = {}, isFetching } = useRatingSummary({ buildingId: building?.id, start, end });
  const buildingLabel = building.account_name ?? '';
  const timeLabel = getDaysLabel(start, end);
  const average = typeof data?.average === 'number' ? data.average : 0;
  const total = typeof data?.total === 'number' ? data.total : 0;
  const distribution = data?.distribution ?? {};

  return (
    <DashboardMetricCardWrapper loading={isFetching} loadingText="Loading rating summary...">
      {total === 0 && (
        <Box sx={{ textAlign: 'center' }}>
          <AnnouncementOutlined color="primary" sx={{ fontSize: 40 }} />
          <Typography color="primary" sx={{ mt: 2 }}>
            No Ratings info
          </Typography>
        </Box>
      )}

      {total > 0 && (
        <RatingSummaryCard
          average={average}
          total={total}
          distribution={distribution}
          buildingLabel={buildingLabel}
          timeLabel={timeLabel}
        />
      )}
    </DashboardMetricCardWrapper>
  );
};
